var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgActivityTask = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 36 36",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M22.498 16.2h-9v-1.8h9zm0 3.6h-9V18h9zm-2.7 3.6h-6.3v-1.8h6.3zm-1.8-12.6a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8m6.3 0h-3.762C20.158 9.756 19.168 9 17.998 9s-2.16.756-2.538 1.8h-3.762a1.8 1.8 0 0 0-1.8 1.8v12.6a1.8 1.8 0 0 0 1.8 1.8h12.6a1.8 1.8 0 0 0 1.8-1.8V12.6a1.8 1.8 0 0 0-1.8-1.8"
})));
export default SvgActivityTask;